export default "__VITE_ASSET__7e268c77__"